import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import config from './config'
import Axios from 'axios'
import FileUpload from 'v-file-upload'
import filters from './filters/filters';


Vue.config.performance = true
Vue.config.productionTip = false

Vue.use(CoreuiVue)
Vue.use(FileUpload)

Vue.prototype.$log = console.log.bind(console)
Vue.prototype.$config = config;
Vue.prototype.$axios = Axios;


Vue.directive('autoresize', {
  inserted: function (el) {
    el.style.overflow = 'hidden';
    el.style.resize = 'none';
    let resize = () => {
      el.style.height = 'auto';
      el.style.height = (el.scrollHeight) + 'px';
    }
    resize();
    el.addEventListener('input', resize);
  },
  update(el) {
    el.style.height = 'auto';
    el.style.height = (el.scrollHeight) + 'px';
  }
});


new Vue({
  el: '#app',
  router,
  store,
  icons,
  config,
  filters,
  template: '<App/>',
  components: {
    App
  }
})
